export const ORDERS_V2_QUERY_KEY = 'ordersV2';
